import cn from 'classnames'
import { Swiper, SwiperSlide } from 'swiper/react'

import { SelectProps } from './interface'

export function SelectLine({ options, value, onChange }: SelectProps) {
  return (
    <div className='w-full'>
      <div className='flex relative z-10'>
        <Swiper slidesPerView='auto'>
          {options.map(row => (
            <SwiperSlide key={row.value}>
              <div>
                <div
                  className={cn(
                    'px-[20px] pb-[10px] text-[14px] cursor-pointer leading-[1.8] ',
                    {
                      'text-secondary-1 font-light': value !== row.value,
                      'text-secondary dark:text-dark-10 font-bold':
                        value === row.value,
                    }
                  )}
                  onClick={() => onChange(row.value)}
                >
                  {row.text}
                </div>
                <hr
                  className={cn(
                    'bg-secondary dark:bg-dark-10 h-[3px] rounded-[1.5px]',
                    {
                      hidden: value !== row.value,
                    }
                  )}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <hr className='text-gray-3 dark:text-purple w-full relative bottom-[1.5px]' />
    </div>
  )
}
